module.exports = __webpack_public_path__ + "img/fig11.39089059.jpg";